import { NOMINAL_DATA, MODULE_ARCHITECTURE, CURRENT_DEPENDENCIES, TEMPERATURE_DEPENDENCIES, THERMAL_CHARACTERISTICS, BASIC_NOMINAL_DATA, ADVANCED_NOMINAL_DATA } from "./constantFeatures";

export function insertPropertiesInFeatures(driverFeatures: Array<Object>, driverProperties: Array<Object>, type: String): Object {
    
    const featureDict: Object = {};

    driverFeatures.forEach(driverFeature => {
        driverFeature.properties = [];
        featureDict[driverFeature.name] = driverFeature;
    });

    driverProperties.forEach(property => {
        const features = getPropertyNameFromFeature(property, type);
        features.forEach(f => {
            const feature = featureDict[f];
                if (feature) {
                feature.properties.push(property);
            }
        });
        
    });

    return featureDict;
}

export function getPropertiesFromFeature(driverFeature: Object, driverProperties: Array<Object>, type: String): Object {

    const properties: Object = {};

    driverProperties.forEach(property => {
        if (getPropertyNameFromFeature(property, type).indexOf(driverFeature.name) !== -1) {
            properties[property.info.name] = property;
        }
    });

    return properties;
}

function getPropertyNameFromFeature(property: Object, type: String): Array<String> {

    const returnValue = [];

    
    if (Object.values(BASIC_NOMINAL_DATA).indexOf(property.info.name) !== -1) {
        returnValue.push(BASIC_NOMINAL_DATA.shortName);
    } 
    if (Object.values(ADVANCED_NOMINAL_DATA).indexOf(property.info.name) !== -1) {
        returnValue.push(ADVANCED_NOMINAL_DATA.shortName);
    }
    if (Object.values(NOMINAL_DATA).indexOf(property.info.name) !== -1) {
        returnValue.push(NOMINAL_DATA.shortName);
    }  

    if (Object.values(MODULE_ARCHITECTURE).indexOf(property.info.name) !== -1) {
        returnValue.push(MODULE_ARCHITECTURE.shortName);
    } 
    if (Object.values(THERMAL_CHARACTERISTICS).indexOf(property.info.name) !== -1) {
        returnValue.push(THERMAL_CHARACTERISTICS.shortName);
    } 
    if (Object.values(CURRENT_DEPENDENCIES).indexOf(property.info.name) !== -1) {
        returnValue.push(CURRENT_DEPENDENCIES.shortName);
    } 
    if (Object.values(TEMPERATURE_DEPENDENCIES).indexOf(property.info.name) !== -1) {
        returnValue.push(TEMPERATURE_DEPENDENCIES.shortName);
    }

    return returnValue;
}